/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_No_Gps_Banner_TextInputs */

const en_ui_no_gps_banner_text = /** @type {(inputs: Ui_No_Gps_Banner_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This session has no GPS data — there's no route to map`)
};

const de_ui_no_gps_banner_text = /** @type {(inputs: Ui_No_Gps_Banner_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Einheit hat keine GPS-Daten — es gibt keine Route auf der Karte`)
};

/**
* | output |
* | --- |
* | "This session has no GPS data — there's no route to map" |
*
* @param {Ui_No_Gps_Banner_TextInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_no_gps_banner_text = /** @type {((inputs?: Ui_No_Gps_Banner_TextInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_No_Gps_Banner_TextInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_no_gps_banner_text(inputs)
	return de_ui_no_gps_banner_text(inputs)
});